export default{
    boletim:'',
}